import React, { useContext } from 'react';

import Bookmark from '../components/Bookmark';
import Button from '../components/Button';

import { motion as m } from 'framer-motion';

import { CursorContext } from '../context/CursorContext';
import { animationVariants } from '../config/animationConstants';

const Contact = () => {
  const buttonConfig = { text: 'Send', id: 3 };

  const { mouseEnterHandler, mouseLeaverHandler } = useContext(CursorContext);

  return (
    <section className='section'>
      <Bookmark />
      <div className='
        col-span-10
        flex flex-col lg:flex-row
        justify-center items-center
        p-4 lg:p-6
      '>
        <m.div
          initial='hidden'
          animate='visible'
          variants={animationVariants}
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaverHandler}
          className='flex flex-1 flex-col justify-center items-center'
        >
          <form
            method='POST'
            action='https://getform.io/f/482bcbf7-2865-4630-8cf4-d5fcfc17d7a7'
            className='flex flex-col gap-4 text-secondary'
          >
            <p className='text-xl text-start'>
              I'm currently looking for a job in Belgium or full-time remote. If
              you want to collaborate, just send me an email at{' '}
              <a
                href='mailto:taguhikarakash@gmail.com'
                target='_blank'
                rel='noreferrer'
                className='underline'
              >
                taguhikarakash@gmail.com
              </a>{' '}
              or submit the form!
            </p>
            <div className='flex flex-col md:flex-row gap-4'>
              <div className='md:w-1/2'>
                <m.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1, delay: 0.3 }}
                  className='flex flex-col gap-4 mt-2 w-full justify-start items-start'
                >
                  <label htmlFor='name'>Name</label>
                  <input
                    className='p-2 w-full h-16 border border-secondary rounded-3xl'
                    type='text'
                    name='name'
                  />
                </m.div>
                <m.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1, delay: 0.6 }}
                  className='flex flex-col gap-4 mt-2 w-full justify-start items-start'
                >
                  <label htmlFor='email'>Email</label>
                  <input
                    className='p-2 w-full h-16 border border-secondary rounded-3xl'
                    type='email'
                    name='email'
                  />
                </m.div>
              </div>
              <div className='md:w-1/2'>
                <m.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1, delay: 0.9 }}
                  className='flex flex-col gap-3  mt-2 items-start'
                >
                  <label htmlFor='message'>Message</label>
                  <textarea
                    className='p-4 w-full resize-none border border-secondary rounded-3xl'
                    name='message'
                    rows='6'>
                  </textarea>
                </m.div>
              </div>
            </div>
            <m.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 1.2 }}
              className='
                flex flex-col-reverse md:flex-row
                justify-between items-center
                gap-4
                text-secondary
              '
            >
              <div className='flex flex-row gap-4 items-start text-secondary'>
                <a
                  href='https://www.linkedin.com/in/taguhikarakashyan/'
                  target='_blank'
                  rel='noreferrer'
                  className='hover:underline'
                >
                  Linkedin
                </a>
                <a
                  href='https://github.com/TaguhiKa'
                  target='_blank'
                  rel='noreferrer'
                  className='hover:underline'
                >
                  Github
                </a>
              </div>
              <Button buttonConfig={buttonConfig} />
            </m.div>
          </form>
        </m.div>
      </div>
    </section>
  );
};

export default Contact;
